import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import LogoutIcon from '@mui/icons-material/Logout';

function AccountMenuLogoutAction({ t, onLogout }) {
	return (
		<Box px={2} pb={2} pt={2}>
			<Button
				variant="contained"
				color="primary"
				size="medium"
				fullWidth
				startIcon={<LogoutIcon fontSize="small" />}
				role="button"
				data-testid="account_logout"
				aria-label={t('logout')}
				onClick={onLogout}
			>
				{t('logout')}
			</Button>
		</Box>
	);
}

AccountMenuLogoutAction.propTypes = {
	t: PropTypes.func.isRequired,
	onLogout: PropTypes.func.isRequired,
};

export default AccountMenuLogoutAction;
